import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">用户评价</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自真实用户的观影体验分享</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {commentItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">&ldquo;{item.text}&rdquo;</p>
              <div className="flex items-center gap-0.5 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}